import { SiGoogledrive } from "react-icons/si";
import { GoogleDriveBrowser } from "@/components/google-drive/GoogleDriveBrowser";
import { GoogleDriveQuickImport } from "@/components/google-drive/GoogleDriveQuickImport";

export default function GoogleDriveKnowledge() {
  return (
    <div className="container max-w-4xl py-8 px-4">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold flex items-center gap-2">
          <SiGoogledrive className="h-7 w-7 text-[#4285F4]" />
          Google Drive
        </h1>
        <p className="text-muted-foreground mt-1">
          Browse your Drive and import files into your Library. Imported Drive files
          are searchable by the Librarian as Library documents (not a live Drive dump).
          Embed them from the Library after import so Claude / GPT / Grok can retrieve snippets.
        </p>
        <div className="mt-4">
          <GoogleDriveQuickImport variant="page" />
        </div>
      </div>
      <GoogleDriveBrowser />
    </div>
  );
}
